/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Entitlement_DeleteInputs */



/**
* | output |
* | --- |
* | "Took back a plan feature" |
*
* @param {Activity_Entitlement_DeleteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_entitlement_delete = /** @type {((inputs?: Activity_Entitlement_DeleteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Entitlement_DeleteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отозвана функция тарифа")
	return /** @type {LocalizedString} */ ("Took back a plan feature")
});